import { useQuery } from '@tanstack/react-query';
import {
  fetchProviderProfile,
  calculateOnboardingStatus,
  type ServiceProviderProfile,
  type OnboardingStatus,
} from '../api/profileApi';

/**
 * React Query hook for fetching provider profile data
 * 
 * Returns profile with automatic caching and refetching
 * Includes computed onboarding status derived from profile data
 * 
 * @returns useQuery result with profile data, onboarding status, loading state, and error
 */
export function useProviderProfile() {
  const query = useQuery<ServiceProviderProfile, Error>({
    queryKey: ['provider', 'profile'],
    queryFn: fetchProviderProfile,
    staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
    refetchOnWindowFocus: true,
    retry: 2,
  });

  // Calculate onboarding status from profile data
  const onboardingStatus: OnboardingStatus = calculateOnboardingStatus(query.data);

  return {
    ...query,
    onboardingStatus,
  };
}

